import {mapiqApi} from '@lib/infrastructure';
import {AppThunkApiConfig} from '../../createStore';
import {createAsyncThunk} from '@reduxjs/toolkit';
import {BlindsValues, Controllable, FeatureToggle, TemperatureValues} from '../entities';
import {controlCompare, ControlValues, roundToClosest} from './utils';

export const loadControlsForNode = createAsyncThunk<Controllable[], string, AppThunkApiConfig>(
  'controls/loadControlsForNode',
  async (nodeId, {extra}) => {
    const client = extra.apiClient;
    const api = mapiqApi(client);
    const response = await api.getControlsForNodeId(nodeId);

    return response.sort(controlCompare).map((c): Controllable => {
      const shared = {id: c.id, displayName: c.displayName, locations: c.locations};

      return c.type === 'temperature'
        ? {
            ...shared,
            type: 'temperature',
            currentValue: c.value === undefined ? undefined : roundToClosest(c.value, ControlValues.temperature),
          }
        : {
            ...shared,
            type: 'blinds',
            currentValue: c.value === undefined ? undefined : roundToClosest(c.value, ControlValues.blinds),
          };
    });
  },
  {
    condition: (_arg, {getState}) => getState().data.features.enabledFeatures.includes(FeatureToggle.Controls),
  },
);

export const updateTemperature = createAsyncThunk<
  void,
  {controlId: string; value: TemperatureValues},
  AppThunkApiConfig
>(
  'controls/updateTemperature',
  async ({controlId, value}, {extra}) => {
    const client = extra.apiClient;
    const api = mapiqApi(client);
    await api.putTemperatureControllableValue(controlId, value);
  },
  {
    condition: (_arg, {getState}) => getState().data.features.enabledFeatures.includes(FeatureToggle.Controls),
  },
);

export const updateBlinds = createAsyncThunk<void, {controlId: string; value: BlindsValues}, AppThunkApiConfig>(
  'controls/updateBlinds',
  async ({controlId, value}, {extra}) => {
    const client = extra.apiClient;
    const api = mapiqApi(client);
    await api.putBlindsControllableValue(controlId, value);
  },
  {
    condition: (_arg, {getState}) => getState().data.features.enabledFeatures.includes(FeatureToggle.Controls),
  },
);
